export class UserProductPermission {
  label: string;
  // 権限が入る予定
  constructor(data: any) {
    this.label = data.label || '';
  }
}
